import type { GetCanNavigatePickerYearParams, GetCanNavigatePickerYearResult } from '../types';

const getCanNavigatePickerYear = ({
    viewYear,
    currentMonth,
    earliestMonth,
}: GetCanNavigatePickerYearParams): GetCanNavigatePickerYearResult => {
    const previousYearLastMonth = `${viewYear - 1}-12`;
    const nextYearFirstMonth = `${viewYear + 1}-01`;

    return {
        canGoPreviousYear: previousYearLastMonth >= earliestMonth,
        canGoNextYear: nextYearFirstMonth <= currentMonth,
    };
};

export default getCanNavigatePickerYear;
